import { I18n } from "@/i18n/I18n";

export function LoadingSpinner() {
  return (
    <div className="spinner-border spinner-border-sm" role="status">
      <span aria-label={I18n.get('loading')} className="visually-hidden">{I18n.get('loading')}</span>
    </div>
  );
}
